import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge Tailwind classes with clsx — the standard shadcn/ui utility. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Read a CSS custom property (HSL triplet) and return an `hsl(...)` string
 * usable in JS-driven chart libraries that don't resolve CSS vars natively.
 *
 * @example getCssColor('--chart-series-1') // "hsl(227 91% 59%)"
 */
export function getCssColor(varName: string): string {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(varName).trim()
  return raw ? `hsl(${raw})` : ''
}
